type DesktopStep = {
    title: string;
    description: string;
    imgSrc: string;
};

export const DESKTOP_STEPS: readonly DesktopStep[] = [
    {
        title: 'Отсканируйте QR-код',
        description: 'Наведите на него камеру айфона и перейдите по ссылке',
        imgSrc: '/webapp-landing-v2/0_step_qr.png',
    },
    {
        title: 'Установите веб-приложение',
        description: 'Нажмите на <b>...</b> внизу экрана <b>→ Поделиться → На экран Домой</b>',
        imgSrc: '/webapp-landing-v2/1_step_icon.png',
    },
    {
        title: 'Откройте веб-приложение',
        description: 'Войдите по номеру телефона',
        imgSrc: '/webapp-landing-v2/3_step_sign_in.png',
    },
    {
        title: 'Установите секретный код',
        description: 'Для безопасного и быстрого входа',
        imgSrc: '/webapp-landing-v2/4_step_code.png',
    },
    {
        title: 'Включите пуш-уведомления',
        description: 'Чтобы узнавать обо всех поступлениях и списаниях с карты',
        imgSrc: '/webapp-landing-v2/5_step_push.png',
    },
    {
        title: 'Подключите удобный вход',
        description: 'По распознаванию лица или отпечатку пальца',
        imgSrc: '/webapp-landing-v2/6_step_face_id.png',
    },
    {
        title: 'Дайте Safari доступ к контактам',
        description:
            'Для переводов по номеру телефона и оплаты связи. Покажем инструкцию при выборе контакта',
        imgSrc: '/webapp-landing-v2/7_step_contacts.png',
    },
];
